import {
  IconButton,
  Popover,
  State,
  STATES,
} from '@innovamat/glimmer-components';

type ClassCardOptions = {
  delete?: {
    text: string;
    onClick: () => void;
    subtitle?: string;
    state?: State;
  };
  edit?: { text: string; onClick: () => void; state?: State };
  leave?: {
    text: string;
    onClick: () => void;
    subtitle?: string;
    state?: State;
  };
  unsynchronize?: {
    text: string;
    onClick: () => void;
    subtitle?: string;
    state?: State;
  };
};

type ClassCardOptionsProps = {
  options?: ClassCardOptions;
  onOpenOptions?: () => void;
};

function ClassCardOptions({
  options = {
    delete: { text: '', onClick: () => {} },
    edit: { text: '', onClick: () => {} },
    leave: { text: '', onClick: () => {} },
    unsynchronize: { text: '', onClick: () => {} },
  },
  onOpenOptions,
}: ClassCardOptionsProps): JSX.Element {
  return (
    <Popover
      popoverProps={{ disablePortal: true }}
      id="class-card"
      trigger={
        <IconButton
          icon="OptionsIcon"
          size="S"
          onClick={() => onOpenOptions?.()}
          dataTestId="class-card-options-dropdown"
        />
      }
    >
      <div
        style={{ minWidth: 264 }}
        data-testid="class-card-options-dropdown-container"
      >
        {options.edit && (
          <Popover.Item
            state={options.edit.state || STATES.ACTIVE}
            icon="EditIcon"
            onSelectItem={options.edit.onClick}
          >
            {options.edit.text}
          </Popover.Item>
        )}
        {options.leave && (
          <Popover.Item
            state={options.leave.state || STATES.ACTIVE}
            icon="LeaveClassIcon"
            onSelectItem={options.leave.onClick}
            subtitle={options.leave.subtitle}
          >
            {options.leave.text}
          </Popover.Item>
        )}
        {options.delete && (
          <Popover.Item
            onSelectItem={options.delete.onClick}
            state={options.delete.state || STATES.ACTIVE}
            icon="DeleteIcon"
            subtitle={options.delete.subtitle}
          >
            {options.delete.text}
          </Popover.Item>
        )}
        {options.unsynchronize && (
          <Popover.Item
            onSelectItem={options.unsynchronize.onClick}
            state={options.unsynchronize.state || STATES.ACTIVE}
            icon="DeleteIcon"
            subtitle={options.unsynchronize.subtitle}
          >
            {options.unsynchronize.text}
          </Popover.Item>
        )}
      </div>
    </Popover>
  );
}

export { ClassCardOptions };
export type { ClassCardOptionsProps };
